import { migrateDeficiency, migrateRisk } from '../graphql';
import { IMigrateRisk } from '../models/models';
import { trackEventFn, TrackingEventType } from '../utilities/hooks/useEventTracking';
import { DeficiencyList, deficiencyListPushModifier } from './deficiencyList/queryBuilder';
import { RiskAssessments } from './riskAssessment/queryBuilder';

export default class MigrationHelper {
  private static _instance: MigrationHelper;

  constructor() {
    MigrationHelper._instance = this;
  }

  public static get instance(): MigrationHelper {
    return MigrationHelper._instance;
  }

  migrateDeficiencyV2 = async (deficiency: DeficiencyList) => {
    const newDoc = {
      ...deficiency,
      fkAsset: deficiency.fkAsset || null,
      fkArea: deficiency.fkArea || null,
      isAdhoc: deficiency.isAdhoc || false,
      isReInspectedComponent: deficiency.isReInspectedComponent || false,
      componentVersionId: deficiency.componentVersionId || null,
      componentVersionInspectionId: deficiency.componentVersionInspectionId || null,
      componentVersionUUID: deficiency.componentVersionUUID || null,
      inspectorOperationalDowntime: deficiency.inspectorOperationalDowntime || null,
      inspectorConditionRating: deficiency.inspectorConditionRating || null,
      inspectorUrgency: deficiency.inspectorUrgency || null,
      inspectorTrafficScore: deficiency.inspectorTrafficScore || null,
    };
    try {
      const payload = deficiencyListPushModifier(newDoc);

      const result = await migrateDeficiency(payload as DeficiencyList);

      if (result?.data?.migrationDeficiencyData?.componentVersionUUID) {
        return result.data.migrationDeficiencyData;
      } else
        throw new Error(
          `No Version UUID Found; request: ${JSON.stringify(payload)}; response: ${JSON.stringify(
            result,
          )} `,
        );
    } catch (error) {
      await trackEventFn(TrackingEventType.DATA_LOG, {
        deficiency: JSON.stringify(deficiency),
        error: JSON.stringify(error),
      });
      console.log('🚀 ~ file: MigrationHelper.ts:51 ~ migrateDeficiencyV2= ~ err:', error);
      return null;
    }
  };

  migrateRiskV1 = async (risk: RiskAssessments) => {
    try {
      const payload: IMigrateRisk = {
        fkDeficiencyUUID: risk.fkDeficiencyUUID,
        fkRiskType: Number(risk.riskType),
        riskValue: Number(risk.riskValue),
      };

      const result = await migrateRisk(payload);

      if (result?.data?.migrationDeficiencyRiskData)
        return {
          assetID: risk.assetID || null,
          activeDeficiencyInspectionId: risk.activeDeficiencyInspectionId || null,
          ...risk,
        };
      else
        throw new Error(
          `Risk Not Saved; request: ${JSON.stringify(payload)}; response: ${JSON.stringify(
            result,
          )}`,
        );
    } catch (error) {
      await trackEventFn(TrackingEventType.DATA_LOG, {
        risk: JSON.stringify(risk),
        error: JSON.stringify(error),
      });
      console.log('🚀 ~ file: MigrationHelper.ts:83 ~ migrateRiskV1= ~ err:', error);
      return null;
    }
  };
}

new MigrationHelper();
